// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const isLocal = window.location.hostname === 'localhost';

export const environment = {
  production: false,
  apiUrl: isLocal ? 'http://localhost:8080' : 'https://development-api.oyecreators.com',
  websiteUrl: isLocal ? 'http://localhost:8100' : 'https://development.oyecreators.com',
  oneSignalAppId: 'eebc4eac-a464-4012-9ef2-56cfb9097d31',
  googleMapsApiKey: 'AIzaSyBoaNey12RUDNZaEk1U3Ndvc-IM4JJgkOQ'
};
